export const GET_USER_MANAGEMENT = 'USER_MANAGEMENT/get_user-_management';
export const GET_SINGLE_USER_MANAGEMENT =
  'USER_MANAGEMENT/get_single_user_management';
export const UPDATE_USER_MANAGEMENT = 'USER_MANAGEMENT/update_user-_management';
export const CREATE_USER_MANAGEMENT = 'USER_MANAGEMENT/create_brangay';
export const REMOVE_USER_MANAGEMENT = 'USER_MANAGEMENT/remove_user_management';
export const ACTIVATE_USER_MANAGEMENT = 'USER_MANAGEMENT/activate_user_management';
export const DEACTIVATE_USER_MANAGEMENT = 'USER_MANAGEMENT/deactivate_user_management';
export const RESET_PASSWORD_USER_MANAGEMENT = 'USER_MANAGEMENT/RESET_PASSWORD_USER_MANAGEMENT';

export const GET_ROLE_LIST = 'ROLE/get_role_list';

export const FORM_DATA = {
  first_name: '',
  last_name: '',
  email: '',
  password: '',
  mobile_number: '',
  photo: '',
  telephone_number: '',
  address: '',
  role_id: '',
};
